<template>
	<div>
		<el-dialog title="查看通知策略及通知结果" top="0px"  :visible.sync="dialogVisible" width="700px" :show-close="false" :before-close="handleClose">
			<div class="biaoti" style="margin-bottom: 15px;">
				<span>通知策略</span>
			</div>
			<el-table :data="tableData" border ref="singleTable" :header-cell-style="{padding:'8px 0'}" :cell-style="cellStyle" @current-change="handleCurrentChange1" highlight-current-row style="width: 100%">
				<el-table-column prop="name" label="通知实例名称" height="30" width="150">
				</el-table-column>
				<el-table-column prop="remark" label="备注" width="150">
				</el-table-column>
				<el-table-column prop="manner" :show-overflow-tooltip="true" label="初始通知方式" width="280">
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="70">
					<template slot-scope="scope">
						<el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog title="通知策略详情" append-to-body :show-close="false" :visible.sync="dialogVisible2" width="700px" :before-close="handleClose2">
				<SetTactics :instanceId="list" ref="setTactics"></SetTactics>
				<span slot="footer" class="dialog-footer">
				    <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
				  </span>
			</el-dialog>
			<div class="biaoti" style="margin: 20px 0 15px 0;">
				<span>通知详情</span>
			</div>

			<el-table :data="tableData2" height="400" :header-cell-style="{padding:'8px 0'}" :cell-style="{padding:'8px 0'}" border highlight-current-row style="width: 100%">
				<el-table-column prop="time" label="通知时间" height="30" width="180">
				</el-table-column>
				<el-table-column prop="obj" label="通知对象" width="100">
				</el-table-column>
				<el-table-column prop="manner" label="通知方式" width="80">
				</el-table-column>
				<el-table-column prop="require" label="通知要求" width="80">
				</el-table-column>
				<el-table-column prop="id" label="发送唯一码" width="200">
				</el-table-column>
				<el-table-column prop="state" label="通知状态" width="80">
				</el-table-column>
				<el-table-column prop="errInfo" label="错误信息" width="230">
				</el-table-column>
				<el-table-column prop="describe" label="通知描述" width="80">
				</el-table-column>
			</el-table>

			<span slot="footer" class="dialog-footer">
			    <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
			    <el-button type="primary" @click="dialogVisible = false">关 闭</el-button>
			  </span>
		</el-dialog>
	</div>
</template>

<script>
	import SetTactics from "./SetTactics.vue";
	import { GetNoticeInstance, GetNoticeResult, GetTransNoticePolicyAggr } from "@/api/modules/basicData/task";
	export default {
		name: "taskListDialog",
		data() {
			return {
				dialogVisible: false, //弹窗
				tableData: [], //表格1
				tableData2: [],
				currentRow: null,
				dialogVisible2: false, //第二个弹窗
				arr: [],
				arr2: [],
				createTimeFormat: function(time) { //格式化时间
					return time ? time.replace("T", " ").substr(0, 19) : ''
				},
				list: null
			}
		},
		provide() {
			return {
				say: this.say
			}
		},
		watch: {
			dialogVisible(val) {
				if(this.dialogVisible) {
					GetNoticeInstance(97, 2).then(res => {
						for(var i = 0; i < res.length; i++) {
							this.arr.push({
								name: res[i].InstanceName,
								remark: res[i].InstanceMemo,
								manner: res[i].InstanceInitialInfo,
								InstanceId: res[i].InstanceId,
								PolicyRelationId: res[i].PolicyRelationId
							})
						}
						this.tableData = this.uniqueArray(this.arr, 'PolicyRelationId')
					});
				}
			}
		},
		methods: {
			say() {
				console.log("提供子页面调用父页面的方法")
			},
			uniqueArray(array, key) { //去重
				var result = [array[0]];
				for(var i = 1; i < array.length; i++) {
					var item = array[i];
					var repeat = false;
					for(var j = 0; j < result.length; j++) {
						if(item[key] == result[j][key]) {
							repeat = true;
							break;
						}
					}
					if(!repeat) {
						result.push(item);
					}
				}
				return result;
			},
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if(columnIndex === 2) { //指定坐标
					return 'padding:8px 0;'
				} else {
					return ''
				}
			},
			handleClose(done) {
				this.dialogVisible = false;
//				this.setCurrent();
//				this.tableData2 = [];
//				this.arr2 = [];
			},
			handleClose2(done) {
				this.dialogVisible2 = false;
				this.$refs.setTactics.clear();
				this.$refs.setTactics.loading = true;
			},

			setCurrent(row) { //默认选中行
				this.$refs.singleTable.setCurrentRow(row);
			},
			handleCurrentChange1(val) {
				this.currentRow = val;
				GetNoticeResult(99, 2, 1117).then(res => {
					console.log(res)
					for(var i = 0; i < res.length; i++) {
						this.arr2.push({
							time: res[i].CREATETIME,
							obj: res[i].RECIVEUSERNAME,
							manner: this.manner(res[i].NOTICETYPE),
							require: this.require(res[i].NOTICERESULT),
							id: res[i].SENDID,
							state: this.state(res[i].CURRENTSTATE),
							errInfo: res[i].ERRORINFO,
							describe: res[i].NOTICELEVEL
						})
					}
					this.tableData2 = this.uniqueArray(this.arr2, 'id')
				});
			},
			handleClick(row) { //查看
				this.dialogVisible2 = true;
				setTimeout(() => {
					console.log(this.currentRow, "currentRow");
					var instanceId = this.currentRow.InstanceId
					GetTransNoticePolicyAggr("14").then(res => {
						console.log(res, 666)
						this.list = res;
					});
					this.$refs.setTactics.create();
				}, 400)
			},
			manner(val) {
				switch(val) {
					case 0:
						val = "IM";
						break;
					case 1:
						val = "微信";
						break;
					case 2:
						val = "短信";
						break;
					case 3:
						val = "电话";
						break;
					default:
						val = "短信";
						break;
				}
				return val
			},
			require(val) {
				switch(val) {
					case 0:
						val = "送出";
						break;
					case 1:
						val = "送达";
						break;
					case 2:
						val = "回复";
						break;

					default:
						val = "送出";
						break;
				}
				return val
			},
			state(val) {
				switch(val) {
					case 0:
						val = "待发送";
						break;
					case 1:
						val = "正在发送";
						break;
					case 2:
						val = "发送成功";
						break;
					case 3:
						val = "已回复";
						break;
					case -1:
						val = "发送失败";
						break;
					default:
						val = "正在发送";
						break;
				}
				return val
			},
		},
		components: {
			SetTactics,
		}
	}
</script>

<style scoped>
	.biaoti {
		text-align: left;
		color: #409EFF;
		font-size: 16px;
		font-weight: bold;
		height: 22px;
		border-left: 2px solid #409EFF;
		line-height: 22px;
		padding-left: 10px;
	}
</style>